(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["splashi-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-sp-config]').forEach(function(root){
  var tip = root.querySelector('[data-sp-tip]');
  root.querySelectorAll('.sp-config-col').forEach(function(col){
    col.addEventListener('click', function(e){
      var btn = e.target.closest('.sp-chip'); if(!btn) return;
      col.querySelectorAll('.sp-chip').forEach(function(c){ c.classList.remove('is-on'); });
      btn.classList.add('is-on');
      if(tip && btn.dataset.tip) tip.textContent = btn.dataset.tip;
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
